// Partner-portál feature — query-kulcs gyár + a lista-szűrő típusa. A hívásokat a route a tipizált ts-rest
// kliensen (`api.portal.tickets` / `api.portal.ticketDetail` / …) intézi; itt csak a kulcsok élnek, hogy az
// invalidálás egy helyről címezhető legyen (a belső feature-ök mintája).

/**
 * A jegy-lista szűrői — a fül, a kereső és a két szűkítő az URL-ben élnek, tehát a cache-kulcs része.
 * (A terv EGY keresőt ad a legacy öt oszlop-szűrője helyett — lásd `portal.tickets.index.tsx`.)
 */
export interface PortalTicketFilters {
  tab: 'in_progress' | 'closed';
  /** Szabad-szöveg: jegy-szám · tárgy · leírás · igénylő · fiók. */
  q: string;
  /** Fiók-azonosító (üres = minden fiók). */
  account: string;
  /** Jegytípus-kulcs (üres = minden típus). */
  type: string;
}

export const portalKeys = {
  all: ['portal'] as const,
  /**
   * A shell adatai (`/portal/me`) — a NYELV és a FIÓK-SCOPE is a kulcs része.
   *
   * A scope azért, mert a nav-jelvények rá szűkülnek: váltásnál új kérés kell, különben a jelvény a régi
   * fiók számát mutatná a friss lista mellett (`null` = „Minden fiók").
   */
  me: (lang: 'hu' | 'en', accountId: string | null) => ['portal', 'me', lang, accountId] as const,
  /** A partnernek szánt FEJLESZTÉSEK (a szöveg nyelve a kulcs része — nyelvváltásra újratölt). */
  productUpdates: (lang: 'hu' | 'en') => ['portal', 'product-updates', lang] as const,
  tickets: () => ['portal', 'tickets'] as const,
  ticketList: (filters: PortalTicketFilters) => ['portal', 'tickets', 'list', filters] as const,
  ticketDetail: (id: string) => ['portal', 'tickets', 'detail', id] as const,
  ticketFormOptions: (accountId: string | undefined) =>
    ['portal', 'tickets', 'form-options', accountId ?? null] as const,
  /** Az üzenet-lap (üzenetek + meghívók) — a NYELV a kulcs része (a nevek/feliratok nyelv-függők). */
  messages: () => ['portal', 'messages'] as const,
  messageList: (lang: 'hu' | 'en', accountId: string | null, archived = false) =>
    ['portal', 'messages', 'list', lang, accountId, archived ? 'archived' : 'inbox'] as const,
  messageDetail: (id: string, lang: 'hu' | 'en') =>
    ['portal', 'messages', 'detail', id, lang] as const,
  /** A számla-lista (fül + kereső az URL-ből, fiók-scope a sidebarból). */
  invoiceList: (filters: { tab: string; q: string; account: string | null }) =>
    ['portal', 'invoices', 'list', filters] as const,
  /** A havi számlázási idővonal (tény + terv) — a fiók-scope és a nyelv a kulcs része. */
  billing: (lang: 'hu' | 'en', accountId: string | null) =>
    ['portal', 'billing', lang, accountId] as const,
  /** Egy számla tételesen (a Számláim lista kibontása) — a nyelv a kulcs része. */
  invoiceDetail: (id: string, lang: 'hu' | 'en') =>
    ['portal', 'invoices', 'detail', id, lang] as const,
  /** A szolgáltatások (időszakokkal) + a várható díj (fiók-szűkítéssel). */
  services: (accountId: string | undefined) => ['portal', 'services', accountId ?? null] as const,
};
